import {createFileRoute} from '@tanstack/react-router'
import {firstLevelLayoutRoute} from "../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg-collection/browse/$primarySorting')({
    ...firstLevelLayoutRoute()
})
